import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { filter, startWith } from 'rxjs';
import {
  ASSETS_BASE_PATH,
  LEGAL_FOOTER_COPYRIGHT,
  LEGAL_FOOTER_USER_REFERENCE,
  PUBLIC_USER_AGREEMENT_PATH,
} from 'src/app/constants/NextGenConstants';

@Component({
  selector: 'app-nextgen-shell',
  imports: [RouterModule],
  templateUrl: './nextgen-shell.component.html',
  styleUrl: './nextgen-shell.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NextGenShellComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  protected shellMainNoPadding = false;
  protected readonly copyright = LEGAL_FOOTER_COPYRIGHT;
  protected readonly userReference = LEGAL_FOOTER_USER_REFERENCE;
  protected readonly publicUserAgreementPath = PUBLIC_USER_AGREEMENT_PATH;
  protected readonly fundsNetworkLogoSrc = `${ASSETS_BASE_PATH}/FundsNetwork-Logo-Color.svg`;
  protected readonly fidelityLogoSrc = `${ASSETS_BASE_PATH}/Fidelity-Logo-Black.svg`;

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.shellMainNoPadding = this.hasRouteDataFlag('shellMainNoPadding');
      });
  }

  private hasRouteDataFlag(flagName: string): boolean {
    let snapshot = this.route.snapshot.firstChild;

    while (snapshot) {
      if (snapshot.data?.[flagName] === true) {
        return true;
      }
      snapshot = snapshot.firstChild ?? null;
    }

    return false;
  }
}
